import clsx from 'clsx'
import {Link} from 'react-router-dom'
import {useAuth} from '../../../../app/modules/auth'
import {SettingsModuleLink} from './SettingsModuleLink'

type Props = {
  menuTrigger?: string
}

export function Settings({menuTrigger = "{default: 'click', lg: 'hover'}"}: Props) {
  const {currentUser} = useAuth()
  const canAccessAdminMenu = !!(currentUser?.administrator || currentUser?.manager)

  return (
    <>
      <a
        href='#'
        className={clsx('btn btn-icon btn-custom position-relative')}
        data-kt-menu-trigger={menuTrigger}
        data-kt-menu-attach='parent'
        data-kt-menu-placement='bottom-end'
      >
        <i className='bi bi-gear fs-3'></i>
      </a>

      <div
        className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-icon-muted menu-active-bg menu-state-primary dash-menu-hover-green fw-semibold py-4 fs-6 w-275px'
        data-kt-menu='true'
      >
        {/* Cada opção no seu próprio `menu-item`: com todas no mesmo item o hover pintava o menu inteiro. */}
        <div className='menu-item px-5'>
          <Link to='/notifications' className='menu-link px-5'>
            <i className='bi bi-bell menu-icon'></i>
            <span className='menu-title'>Notificações</span>
          </Link>
        </div>

        {canAccessAdminMenu && (
          <>
            <div className='menu-item px-5'>
              <Link to='/stages' className='menu-link px-5'>
                <i className='bi bi-kanban menu-icon'></i>
                <span className='menu-title'>Etapas</span>
              </Link>
            </div>

            <div className='menu-item px-5'>
              <Link to='/holidays' className='menu-link px-5'>
                <i className='bi bi-calendar-event menu-icon'></i>
                <span className='menu-title'>Feriados</span>
              </Link>
            </div>

            <div className='menu-item px-5'>
              <Link to='/admin/integrations' className='menu-link px-5'>
                <i className='bi bi-plug menu-icon'></i>
                <span className='menu-title'>Integrações</span>
              </Link>
            </div>

            <div className='menu-item px-5'>
              <Link to='/admin/api' className='menu-link px-5'>
                <i className='bi bi-braces menu-icon'></i>
                <span className='menu-title'>API</span>
              </Link>
            </div>

            <div className='menu-item px-5'>
              <SettingsModuleLink to='/modelos-projetos' moduleSlug='modelos-de-projetos' icon='bi bi-folder'>
                <span className='menu-title'>Modelos de Projetos</span>
              </SettingsModuleLink>
            </div>

            <div className='menu-item px-5'>
              <SettingsModuleLink to='/modelos-tarefas' moduleSlug='modelos-de-tarefas' icon='bi bi-file-earmark-text'>
                <span className='menu-title'>Modelos de Tarefas</span>
              </SettingsModuleLink>
            </div>

            <div className='menu-item px-5'>
              <SettingsModuleLink
                to='/modelos-cronogramas'
                moduleSlug='modelos-de-cronograma'
                icon='bi bi-calendar2-week'
              >
                <span className='menu-title'>Modelos de Cronograma</span>
              </SettingsModuleLink>
            </div>
          </>
        )}
      </div>
    </>
  )
}
